import * as React from 'react';
import { Notification as INotification } from '../models/interfaces';
import Notification from './Notification';
import { inject, observer } from 'mobx-react';
import { NOTIFICATION_STORE } from '../constants/constants';
import { observable } from 'mobx';

@inject(NOTIFICATION_STORE)
@observer
class NotificationContainer extends React.Component {

  dismissNotification(id: number) {
    this.props[NOTIFICATION_STORE].dismissNotification(id);
  }

  getNotifications() {
    if (this.props[NOTIFICATION_STORE].allUnseenNotifications.length) {
      return this.props[NOTIFICATION_STORE].allUnseenNotifications.map((notification: INotification, index: number) =>
        (
          <Notification
            key={index}
            notification={notification}
            dismissNotification={(id: number) => this.dismissNotification(id)}
            id={index}
          />
        )
      );
    }

    return '';
  }

  getClassName() {
    let className = 'notification-container';

    if (!this.props[NOTIFICATION_STORE].allUnseenNotifications.length) {
      className += ' notification-container--empty';
    }
    return className;
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.getNotifications()}
      </div>
    );
  }
}

export default NotificationContainer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotificationContainer.tsx